import { defineComponent as _defineComponent } from 'vue'
import { onMounted, onUnmounted, provide, ref, shallowRef } from 'vue'
import mapboxgl, { Map } from 'mapbox-gl'
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css'
import { MapBoxProvideInstanceEnum } from './enums/MapBoxProvideInstance.enum'
import MapboxDraw from '@mapbox/mapbox-gl-draw'

type LoadEmitPayload = {
	map: Map
	draw?: MapboxDraw
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MapBoxMap',
  props: {
    draw: { type: Boolean }
  },
  emits: ["load"],
  setup(__props: any, { emit }: { emit: ({
	(event: 'load', value: LoadEmitPayload): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	draw?: boolean
};



const mapContainer = ref()
const mapInstance = shallowRef<Map | undefined>(undefined)
provide(MapBoxProvideInstanceEnum.MAP, mapInstance)

const drawInstance = shallowRef<MapboxDraw | undefined>(undefined)
provide(MapBoxProvideInstanceEnum.DRAW, drawInstance)



function createMap() {
	mapboxgl.accessToken = process.env.VUE_APP_MAP_BOX_ACCESS_TOKEN

	mapInstance.value = new Map({
		container: mapContainer.value,
		center: [0, 0],
		zoom: 9,
		style: 'mapbox://styles/mapbox/satellite-v9',
	})

	if (props.draw) {
		drawInstance.value = new MapboxDraw({
			displayControlsDefault: false,
		})

		mapInstance.value.addControl(drawInstance.value!)
	}

	mapInstance.value.on('load', (map) => {
		emit('load', { map: map.target, draw: drawInstance.value })
	})
}

onMounted(() => {
	createMap()

	const resizeObserver = new ResizeObserver(() => {
		mapInstance.value!.resize()
	})
	resizeObserver.observe(mapContainer.value)

	onUnmounted(() => {
		resizeObserver.disconnect()
		mapInstance.value!.remove()
	})
})

return { __sfc: true,props, mapContainer, mapInstance, drawInstance, emit, createMap }
}

})